"use client";

import React from "react";
import { MapPin, Clock, TrainFront, Phone, Mail } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Table, TableHeader, TableBody, TableHead, TableRow, TableCell } from "@/components/ui/table";
const transportOptions = [{
  line: "MTR Island Line",
  stop: "Central Station",
  distance: "5 min walk"
}, {
  line: "Star Ferry",
  stop: "Central Pier",
  distance: "8 min walk"
}, {
  line: "Airport Express",
  stop: "Hong Kong Station",
  distance: "10 min walk"
}];
export default function OurLocation() {
  return;
}